import React, { useState } from "react";
import { Modal, Table, Divider, Typography } from "antd";
import Button from "../../../shared/globalStyling/Button";
import { formatDate } from "../../Creatives/utils";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import MediaFetcher from "../library/MediaFetcher";
import { Carousel } from "antd";
import { filterAdGroupsByMediaType } from "../../Creatives/utils/mediaUtils";

const PrevArrow = props => {
  const { className, style, onClick } = props;
  return (
    <LeftOutlined
      className={className}
      style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
      onClick={onClick}
    />
  );
};

const NextArrow = props => {
  const { className, style, onClick } = props;
  return (
    <RightOutlined
      className={className}
      style={{ ...style, fontSize: "24px", color: "gray", zIndex: 1 }}
      onClick={onClick}
    />
  );
};

const AddCreativesModal = ({
  ids,
  adGroupModalVisible,
  setAdGroupModalVisible,
  setAdGroupModal,
  adGroupCreatives,
  selectedAdUnits,
  handleAssignAdUnits,
  setSelectedAdGroupIds,
  selectedAdGroupIds,
}) => {
  const [assigning, setAssigning] = useState(false);

  const imageAdGroups = filterAdGroupsByMediaType(adGroupCreatives, "STILL");

  const displayAdUnits = [
    {
      title: "Ad Unit Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Aspect",
      dataIndex: "aspect",
      key: "aspect",
      render: (text, record) => `${record.width}x${record.height}`,
    },
    {
      title: "File Type",
      dataIndex: "fileType",
      key: "fileType",
    },
    {
      title: "Uploaded At",
      dataIndex: "uploaded",
      key: "uploaded",
      render: text => formatDate(text),
    },
  ];

  const availableAdgroup = [
    {
      title: "Display Ad Group Name",
      dataIndex: "name",
      key: "name",
      width: "20%",
    },
    {
      title: "Ad Units",
      dataIndex: "AD Unit Number",
      key: "Ad Unit Number",
      width: "6%",
      render: (_, record) => record.medias.length,
    },
    {
      title: "Gallery",
      dataIndex: "medias",
      key: "medias",
      render: medias => {
        // Dynamic carousel settings based on number of items
        const mediaArray = Array.isArray(medias) ? medias : [];
        const itemCount = mediaArray.length;
        const slidesToShow = Math.min(itemCount, 5); // Display modals show 5 items max
        const slidesToScroll = Math.min(itemCount, 5);

        const settings = {
          dots: false,
          infinite: itemCount > slidesToShow, // Only infinite if more items than shown
          speed: 500,
          slidesToShow,
          slidesToScroll,
          arrows: itemCount > slidesToShow, // Only show arrows if scrolling is needed
          prevArrow: <PrevArrow />,
          nextArrow: <NextArrow />,
        };

        return (
          <div style={{ width: "45%", maxWidth: "750px", margin: "0 auto" }}>
            <Carousel {...settings}>
              {Array.isArray(medias)
                ? medias.map((media, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100px",
                      }}
                    >
                      <div
                        style={{
                          maxWidth: "100px",
                          maxHeight: "100px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <MediaFetcher
                          mediaKey={media.key}
                          width="100%"
                          height="100px"
                          objectFit="contain"
                        />
                      </div>
                    </div>
                  ))
                : null}
            </Carousel>
          </div>
        );
      },
    },
    {
      title: "Last Updated",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "10%",
      render: text => formatDate(text),
    },
  ];
  return (
    <Modal
      title={`SELECTED CREATIVE(S) - ${
        ids && ids.length ? ids.length : 0
      } Creative(s) Selected`}
      open={adGroupModalVisible}
      footer={null}
      width={1000}
      onCancel={() => {
        setAdGroupModalVisible(false);
      }}
    >
      <Table
        columns={displayAdUnits}
        dataSource={selectedAdUnits}
        style={{ maxHeight: 200, overflow: "scroll" }}
        pagination={false}
      />
      <Divider style={{ marginTop: "40px", marginBottom: "30px" }} />
      <Typography.Title level={5}>
        SELECT DISPLAY AD GROUP FOR ASSIGNMENT
      </Typography.Title>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          type="primary"
          onClick={async () => {
            setAssigning(true);
            try {
              await handleAssignAdUnits(selectedAdGroupIds, ids);
              setAdGroupModalVisible(false); // close modal after assigning
              setSelectedAdGroupIds([]);
            } catch (error) {
              // Error handling is typically done in the handleAssignAdUnits function
              // but we still need to reset loading state
            } finally {
              setAssigning(false);
            }
          }}
          disabled={!selectedAdGroupIds || selectedAdGroupIds.length === 0 || assigning}
          loading={assigning}
        >
          Assign to Ad Group
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setAdGroupModal(true);
            setSelectedAdGroupIds([]);
          }}
        >
          Create New Ad Group
        </Button>
      </div>
      <div style={{ height: 20 }} />
      <Table
        columns={availableAdgroup}
        dataSource={imageAdGroups.map(data => ({ key: data.id, ...data }))}
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: selectedAdGroupIds,
          onChange: selectedRowKeys => {
            setSelectedAdGroupIds(selectedRowKeys);
          },
        }}
      />
    </Modal>
  );
};

export default AddCreativesModal;
